import { MutationTree } from 'vuex'
import { MutationTypes } from './types'
import { State, defaultItem } from './state'
import { TagAction, TagItem } from './../../../components/Tags/types'

export type Mutations<S = State> = {
  [MutationTypes.TOGGLE_DIALOG](state: S, payload: boolean): void;
  [MutationTypes.SET_ACTION](state: S, payload: TagAction): void;
  [MutationTypes.SET_ITEM](state: S, payload: TagItem): void;
  [MutationTypes.RESET_ITEM](state: S): void;
  [MutationTypes.SET_LABEL](state: S, payload: string): void;
  [MutationTypes.SET_TITLE](state: S, payload: string): void;
  [MutationTypes.SET_TYPE](state: S, payload: string): void;
  [MutationTypes.SET_ITEMS](state: S, payload: any[]): void;
  [MutationTypes.SET_SELECTED](state: S, payload: any[]): void;
  [MutationTypes.SET_NOTIFICATION](state: S, payload: any): void;
}

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.TOGGLE_DIALOG] (state, b) { state.dialog.active = b },
  [MutationTypes.SET_ACTION] (state, a) { state.dialog.action = a },
  [MutationTypes.SET_ITEM] (state, i) { state.dialog.item = i || defaultItem },
  [MutationTypes.RESET_ITEM] (state) { state.dialog.item = defaultItem },
  [MutationTypes.SET_LABEL] (state, s) { state.dialog.label = s },
  [MutationTypes.SET_TITLE] (state, s) { state.dialog.title = s },
  [MutationTypes.SET_TYPE] (state, s) { state.dialog.type = s },
  [MutationTypes.SET_ITEMS] (state, xs) { state.dialog.items = xs },
  [MutationTypes.SET_SELECTED] (state, xs) { state.dialog.selected = xs },
  [MutationTypes.SET_NOTIFICATION] (state, { type, message }) {
    state.error = {
      show: true,
      type,
      message
    }
  }
}
